import { convertToTitleCase, convertBoolIntoString } from "utils/helper";
import React from "react";

import styles from "../ReviewAndSubmit.module.css";

export interface IInfoProps {
  question?: string;
  answer?: any;
  questionFieldName: string;
}

const Info = ({
  questionFieldName,
  question,
  answer,
}: IInfoProps): JSX.Element => {
  const renderAnswer = (answer?: boolean | number | string) => {
    if (typeof answer == "boolean") {
      return convertBoolIntoString(answer);
    }

    // Temp solution
    if (questionFieldName === "exemptionStatus" && typeof answer == "string") {
      return convertToTitleCase(answer);
    }

    return answer;
  };

  const treatedAnswer = renderAnswer(answer);

  return treatedAnswer ? (
    <div className={styles.containerInfo} data-testid="saved-info">
      <div className={styles.question}>{question}</div>
      <div className={styles.answer} data-dd-privacy="mask">
        {treatedAnswer}
      </div>
    </div>
  ) : (
    <></>
  );
};

export default Info;
